export const environment = {
  production: false,
  apiBaseUrl: 'https://atalaiastintasapi.gabrielsanztech.com.br'
};
